
<template>
  <v-card elevation="0">
    <v-card-title>
      {{$t('workspace.areas', locale)}}
      <v-spacer />
      <v-btn
        color="primary"
        fab
        elevation="0"
        small
        @click="handleAddItem"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text style="padding:0px;">
      <draggable-table-area
        :data="data"
        :onCancelEdit="handleCancelEdit"
        :onSortItems="handleSortItems"
        :onSortStart="handleSortStart"
        :onGetData="handleGetData"
        :onEdit="handleEdit"
        :onDelete="handleDelete"
      />
      <area-form 
        :showForm="showForm"
        :data="editedItem"
        :onClose="handleCancelEdit"
        :onDelete="handleDelete"
        :onChangeArea="handleChangeArea"
      />
    </v-card-text>
  </v-card>
</template>
<script>
  const defaultItem = {
    ID: null,
    Name: null,
    ORD: null
  }
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import DraggableTableArea from './DraggableTableArea'
  import AreaForm from './AreaForm'
  export default{
    name: 'Areas',
    components: {
      DraggableTableArea,
      AreaForm,
    },
    props: {
      workspaceID: {
        type: String,
        required: true
      },
      onChangeAreas: {
        type: Function,
        required: true
      },
    },
    data () {
      return {
        tmpNewItemID: 0,
        showForm: false,
        editedItem: null,
        data: [
        ],
      }
    },
    computed: {
      ...mapState('app', ['locale']),
    },
    mounted () {
      this.handleGetData()
    },
    methods: {
      handleGetData () {
        api.getAllWithoutLimit ('queue', `private/workspaces/${this.workspaceID}/areas`)
          .then(response => {
            this.data = response
            this.onChangeAreas(this.data)
          })
      },
      handleCancelEdit () {
        this.showForm = false
      },
      handleSortItems (v) {
        this.data = v
        if (this.data && this.data.length)
          for (let i = 0; i < this.data.length; i++) {
            this.data[i].ORD = i
          }
      },
      handleSortStart () {
      },
      activeDragable () {
      },
      handleEdit (v) {
        this.editedItem = v
        this.showForm = true
      },
      handleDelete (v) {
        this.data = this.data.filter(x => `${x.ID}${x.tmpNewItemID}` !== v)
        this.onChangeAreas(this.data)
      },
      handleChangeArea (v) {
        if(this.data.filter(x => `${x.ID}${x.tmpNewItemID}` === `${v.ID}${v.tmpNewItemID}`).length > 0) {
          this.data = this.data.map(item => {
            if (`${item.ID}${item.tmpNewItemID}` === `${v.ID}${v.tmpNewItemID}`) return v
            else return item
          })
        } else {
          const max = this.data && this.data.length > 0 ? this.data.reduce((prev, current) => (prev.ORD > current.ORD) ? prev : current).ORD : null
          v.ORD = max && max >= 0 ? max + 1 : 1
          this.data.push(v)
        }
        this.onChangeAreas(this.data)
        this.showForm = false
      },
      handleAddItem () {
        this.editedItem = JSON.parse(JSON.stringify(defaultItem))
        this.editedItem.tmpNewItemID = this.tmpNewItemID.toString()
        this.tmpNewItemID ++

        this.showForm = true
      }
    }
  }
</script>
